<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 slot="header" class="card-title">Modification d'un client </h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="backToList()">
            <span><i class="fas fa-arrow-circle-left mr-2"></i> Retour</span>
          </n-button>
        </div>
        <div class="mr-4 ml-4 mb-4">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <form ref="customer_form" @submit.prevent="save()">
            <div class="row">
              <div class="col-lg-3 ml-auto">
                <label class="input-label">Nom</label>
                <fg-input placeholder="Nom" autocomplete="off" name="name" v-validate="'required'" :error="errors.first('name')"
                          v-model="customer.name" style="margin-bottom: 28px" addon-left-icon="now-ui-icons shopping_tag-content"/>
              </div>
              <div class="col-lg-3 mr-auto">
                <label class="input-label">Type</label>
                <fg-input class="select" style="margin-bottom: 28px" name="type" v-model="customer.article_types" v-validate="'required'">
                  <el-select :class="errors.first('type') ? 'has-error':''"  id="article" placeholder="Choisir un type d'article" v-model="customer.article_types" multiple filterable>
                    <el-option v-for="type in type_select_options" :key="type.id" :label="type.name" :value="type.id"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('type')">
                      {{ errors.first('type') }}
                    </div>
                  </slot>
                </fg-input>
              </div>
            </div>

            <div class="row">
              <n-button type="primary" class="btn btn-sm btn-primary mr-auto ml-auto mt-4" @click.native="save()">
                <span> Enregistrer </span>
              </n-button>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Authorizable from "@/mixins/authorizable";
import Spinner from "@/components/Spinner/Circle";
import { Select, Option } from 'element-ui'
import Form from "vform";

export default {
  name: "CustomerForm",
  mixins: [Authorizable],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    Spinner
  },
  data() {
    return {
      isLoaded: false,
      type_select_options : [],
      customer: new Form({
        id: '',
        name: '',
        article_types: []
      })
    };
  },
  mounted(){
    this.isLoaded = true
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`article/type/list`).then((response) => {
      this.type_select_options = response.data
    })
    this.customer.id = this.$route.params.customer.id
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`customer/`+this.$route.params.customer.id).then((response) => {
      this.customer.name = response.data.name
      response.data.article_types.forEach( article_type => {
        this.customer.article_types.push(article_type.id)
      })
    })
  },
  methods: {
    backToList(){
      this.$router.push({ name: 'Customer List' })
    },
    save(){
      this.$validator.validateAll().then( value => {
        if (value === true) {

          this.customer.post(process.env.VUE_APP_API_BASE_URL+`customer/update`).catch(error => {

          }).then( response => {
            // Notification en cas de succès & redirection
            this.$notify({message: 'Le client a bien été mis à jour', type: 'success', verticalAlign: 'bottom'})
            this.backToList();
          })

        }
      })
    }
  }
}
</script>

<style scoped>

</style>